import React, { useMemo } from 'react';
import styles from './Advt.module.css';

import { useGetParams } from '../../hooks/useGetParams';
import logoDefault from '../../assets/images/logo.png';
import { iconsSources } from '../../helpers/icons';
import { formatPhoneNumber } from '../../helpers/titreHelper';

export const Advt = React.memo(() => {
  const {
    phoneNumber,
    title,
    socials,
    qrTitle1,
    qrCode1,
    qrTitle2,
    qrCode2,
    phoneNumberFontSize,
    titleFontSize,
    sizeQR,
    paddingQR,
    logo,
    sizeLogo,
  } = useGetParams();

  let phoneNumberFormat = formatPhoneNumber(phoneNumber, '-');
  const socialsList = useMemo(() => socials?.split(','), [socials]);

  return (
    <div
      className={styles.advtBlock}
      // если нет лого
      style={{ paddingTop: !logo || logo === '0' ? '16rem' : '5rem' }}>
      {logo && logo !== '0' && (
        <div
          className={styles.logoBlock}
          style={{
            width: `${sizeLogo}rem`,
          }}>
          <img src={logo === '1' ? logoDefault : logo} alt="logo" />
        </div>
      )}

      {title && (
        <div
          className={styles.title}
          style={{ fontSize: `${titleFontSize}rem` }}>
          {title}
        </div>
      )}

      <div
        className={styles.numberWrapper}
        style={{ flexWrap: socialsList?.length > 2 ? 'wrap' : 'nowrap' }}>
        {phoneNumber && (
          <div
            className={styles.phoneNumber}
            style={{ fontSize: `${phoneNumberFontSize}rem` }}>
            {phoneNumberFormat}
          </div>
        )}

        {socials && (
          <div className={styles.socialsBlock}>
            {socialsList &&
              socialsList?.map((item) => (
                <div key={item} className={styles.iconSocial}>
                  <img src={iconsSources[item]} alt="social" />
                </div>
              ))}
          </div>
        )}
      </div>
      <div className={styles.qrsWrapper}>
        {qrCode1 && (
          <div className={styles.qrItem}>
            {qrTitle1 && <div className={styles.qrTitle}>{qrTitle1}</div>}
            <div
              className={styles.qr}
              style={{
                height: `${sizeQR}rem`,
                width: `${sizeQR}rem`,
                padding: `${paddingQR}rem`,
              }}>
              <img
                src={qrCode1}
                alt="QR"
                style={{ borderRadius: paddingQR === '0' ? '2rem' : '0' }}
              />
            </div>
            {qrCode1 && qrCode2 ? (
              <div
                className={styles.bubbleOrang}
                style={{
                  height: `${0.6 * Number(sizeQR)}rem`,
                  width: `${0.6 * Number(sizeQR)}rem`,
                  bottom: `${0.52 * Number(sizeQR)}rem`,
                }}
              />
            ) : (
              <>
                <div
                  className={styles.bubbleBlueOneQR}
                  style={{
                    height: `${0.82 * Number(sizeQR)}rem`,
                    width: `${0.82 * Number(sizeQR)}rem`,
                    bottom: `${0.22 * Number(sizeQR)}rem`,
                  }}
                />
                <div
                  className={styles.bubbleOrangOneQR}
                  style={{
                    height: `${0.4 * Number(sizeQR)}rem`,
                    width: `${0.4 * Number(sizeQR)}rem`,
                  }}
                />
              </>
            )}
          </div>
        )}
        {qrCode2 && (
          <div className={styles.qrItem}>
            {qrTitle2 && <div className={styles.qrTitle}>{qrTitle2}</div>}
            <div
              className={styles.qr}
              style={{
                height: `${sizeQR}rem`,
                width: `${sizeQR}rem`,
                padding: `${paddingQR}rem`,
              }}>
              <img
                src={qrCode2}
                alt="QR"
                style={{ borderRadius: paddingQR === '0' ? '2rem' : '0' }}
              />
            </div>
            {qrCode1 && qrCode2 ? (
              <div
                className={styles.bubbleBlue}
                style={{
                  height: `${0.82 * Number(sizeQR)}rem`,
                  width: `${0.82 * Number(sizeQR)}rem`,
                }}
              />
            ) : (
              <>
                <div
                  className={styles.bubbleBlueOneQR}
                  style={{
                    height: `${0.82 * Number(sizeQR)}rem`,
                    width: `${0.82 * Number(sizeQR)}rem`,
                    bottom: `${0.22 * Number(sizeQR)}rem`,
                  }}
                />
                <div
                  className={styles.bubbleOrangOneQR}
                  style={{
                    height: `${0.4 * Number(sizeQR)}rem`,
                    width: `${0.4 * Number(sizeQR)}rem`,
                  }}
                />
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
});
